import { makeStyles } from '@material-ui/core/styles'
import AccordionBase from '../../../2compounds/AccordionBase'
import useNote from './useNote'

/**
 * Note widget component to add description
 * @param editMode boolean
 * @param admin boolean
 * @param data
 * @param index number
 * @param formikProps
 * @param resetToDefault
 * @param updateCardLabel
 * @param isCardDirty
 */

const Note = ({ editMode, admin, data, index, formikProps, resetToDefault, updateCardLabel, isCardDirty, toggleIsHiddenCard, layoutDefaultData }) => {
  const classes = useStyles({ admin })
  const { label } = data
  const { viewSwitcher, isOpen, setIsOpen } = useNote()

  return (
    <AccordionBase
      label={label} isOpen={admin ? true : isOpen} setIsOpen={setIsOpen} className={classes.root}
      admin={admin} index={index} data={data} updateCardLabel={(newValue) => updateCardLabel(index, newValue)}
      resetToDefault={resetToDefault} isCardDirty={isCardDirty} toggleIsHiddenCard={toggleIsHiddenCard} layoutDefaultData={layoutDefaultData}
    >
      <div className={classes.itemRow}>
        {viewSwitcher(data.cardData, 0, editMode, admin, classes, index, formikProps, label)}
      </div>
    </AccordionBase>
  )
}

export default Note

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    gridColumn: 'span 4',
    gridRow: 'span 4',
    border: props => props.admin ? `1px dashed ${theme.palette.tertiary.main}` : 'none',
    '& .MuiAccordion-region': {
      height: '100%'
    },
    '& .MuiAccordionDetails-root': {
      height: '100%'
    }
  },
  itemRow: {
    paddingLeft: 30,
    marginTop: 20,
    height: '100%'
  }
}))
